import Vue from 'vue';
import VueRouter from 'vue-router';

// eslint-disable-next-line import/no-cycle
import store from '@client/store';
import {pageView} from '@client/util/analytics';

// eslint-disable-next-line import/no-cycle
import AccountRoutes from '@client/routes/account';
// eslint-disable-next-line import/no-cycle
import docVaultRoutes from '@client/routes/docVault';
import errorRoutes from '@client/routes/errors';
// eslint-disable-next-line import/no-cycle
import GoalRoutes from '@client/routes/goal';
import liquidationRoutes from '@client/routes/liquidation';
// eslint-disable-next-line import/no-cycle
import loginRoutes from '@client/routes/login';
// eslint-disable-next-line import/no-cycle
import OnboardingRoutes from '@client/routes/onboarding';
// eslint-disable-next-line import/no-cycle
import overviewRoutes from '@client/routes/overview';
// eslint-disable-next-line import/no-cycle
import profileRoutes from '@client/routes/profile';
// eslint-disable-next-line import/no-cycle
import riskToleranceRoutes from '@client/routes/riskTolerance';
import exploreMoreRoutes from '@client/routes/exploreMore';
// eslint-disable-next-line import/no-cycle
import RootRoutes from '@client/routes';
import ssoRoutes from '@client/routes/sso';
// eslint-disable-next-line import/no-cycle
import TransfersRoute from '@client/routes/transfers';
// eslint-disable-next-line import/no-cycle
import beforeEach from '@client/util/router';

// eslint-disable-next-line import/no-cycle
import performanceRoutes from '@client/routes/performance';

import omit from 'lodash.omit';

import './router-error';

// Don't install the router automatically when running tests - this prevents some components from mocking $router.
if (process.env.NODE_ENV !== 'test') {
  Vue.use(VueRouter);
}

const routeDefaults = {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  header: () => import('@client/layouts/authenticated/Header.vue'),
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  footer: () => import('@client/layouts/Footer.vue'),
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const preprocessRoutes = (route) => {
  if (route.meta?.useLayouts) {
    return route;
  }

  const components = {
    ...routeDefaults,
    ...(route.component ? {default: route.component} : {}),
    ...route.components,
  };

  const processed = {components, ...omit(route, ['component', 'components'])};

  if (processed.props === true) {
    // eslint-disable-next-line unicorn/no-array-reduce, unicorn/prefer-object-from-entries
    processed.props = Object.keys(components).reduce((acc, val) => {
      // eslint-disable-next-line no-param-reassign
      acc[val] = true;

      return acc;
    }, {});
  }

  return processed;
};

const routes = [
  ...AccountRoutes,
  ...docVaultRoutes,
  ...errorRoutes,
  ...GoalRoutes,
  ...loginRoutes,
  ...profileRoutes,
  ...OnboardingRoutes,
  ...overviewRoutes,
  ...riskToleranceRoutes,
  ...RootRoutes,
  ...ssoRoutes,
  ...TransfersRoute,
  ...liquidationRoutes,
  ...performanceRoutes,
  ...exploreMoreRoutes,
].map((unprocessedRoutes) => preprocessRoutes(unprocessedRoutes));

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  scrollBehavior: (_to, _from, savedPosition) => savedPosition || {x: 0, y: 0},
});

beforeEach.forEach((beforeEachFunction) => {
  router.beforeEach(beforeEachFunction);
});

router.afterEach((to, from) => {
  store.dispatch('setLoading', false);
  pageView(to, from);
});

export default router;
